/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetTikTokCreatorInfoQueryResponse, GetTikTokCreatorInfoPathParams } from "../models/GetTikTokCreatorInfo";

export function getGetTikTokCreatorInfoUrl(station: GetTikTokCreatorInfoPathParams["station"]) {
  const res = { method: 'GET', url: `/tiktok/${station}/creator-info` as const }
  return res
}

/**
 * @description Returns TikTok creator profile and permission info (privacy options, comment/duet/stitch settings, max video duration). Use when rendering the Post to TikTok page per Content Sharing Guidelines.
 * @summary Get TikTok creator info for a station
 * {@link /tiktok/:station/creator-info}
 */
export async function getTikTokCreatorInfo(station: GetTikTokCreatorInfoPathParams["station"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetTikTokCreatorInfoQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetTikTokCreatorInfoUrl(station).url.toString(), ... requestConfig })
  return res.data
}